import CircularPageLoader from 'components/Loader/CircularPageLoader'

import FlexibleTable from 'components/EnhancedTable/FlexibleTable'
import TabbedPopUp from 'components/PopUp/TabbedPopUp'
import {
  dataTabLabelsShipped,
  dataTabLabelsShippedWithProps,
  dataTabLabelsShippedWithScenic
} from 'enums/tableTabs'
import { makeTabTables, getTitle } from 'util/Table'
import { withStyles } from '@material-ui/core/styles'
import { valueToCheckAgainst } from 'store/newShipment/reducer'
import { PROPS, SAMPLE, SCENIC } from 'enums/Tabs'
import { createCsvUtil } from 'pages/SearchInventoryPage/SearchUtils'
import apiConfig from 'apiConfig'
import { useDispatch } from 'react-redux'
import { CsvDwonloadScenic } from 'store/newShipment/actionCreator'
const FlexibleTableNew = withStyles((theme) => ({
  root: {
    boxShadow: 'unset !important',
  },
  container: {
    maxHeight: 'unset !important',
  },
  header: {
    backgroundColor: 'unset',
    fontWeight: 700,
  },
}))(FlexibleTable)

const ShipmentTableData = ({
  addSamplesRequestPending,
  checkBoxEnabled,
  columnData,
  renderData,
  onClick,
  onEditChange,
  numSelected,
  onCheckBoxChange,
  onCheckBoxHeaderChange,
  page,
  rowsPerPage,
  selectedData,
  setPage,
  setRowsPerPage,
  showPopup,
  clickableColumn,
  isReuseShipment = false,
  isShipmentInfoReadOnly,
  isShipped = false,
  dataShipmentId = '',
  popupIsVisible,
  popupItem = {},
  closePopup = () => {},
  updateSampleFieldsData = () => {},
  classes = {},
  downloadContactSheet = () => {},
  isAuthorized = () => {},
}) => {
  const dataFieldKeys = columnData.map((column) => column.id)

  const onSelected = (selectedData = [], selected = {}) => {
    const { pegasusId: selectedPGID = '' } = selected
    return selectedData.some((obj) => {
      return !selected.isShippedEntity ? obj.pegasusId === selectedPGID : false
    })
  }
  const dispatch = useDispatch()
  let readOnlyProps = {}

  const downloadCSFunction =
    (shipmentId = '', downloadType = '') =>
    () => {
      const paramsCopy = {
        include_filters: {},
        exclude_filters: {},
      }

      const dataTypes = [...new Set(renderData.map((item) => item.itemType))]
      const itemType =
        dataTypes.length === 2
          ? 'COMBINED'
          : dataTypes[0] === SAMPLE
            ? SAMPLE
            : dataTypes[0] === PROPS
              ? PROPS
              : SCENIC

      downloadContactSheet(
        Object.assign({}, paramsCopy, {
          ...paramsCopy,
          include_filters: {
            shipment_id: [shipmentId],
          },
        }),
        downloadType,
        itemType
      )
    }

  const dataTypes = [...new Set(renderData.map((item) => item.itemType))]
  const itemType =
    dataTypes.length >=2
      ? 'COMBINED'
      : dataTypes[0] === SAMPLE
        ? SAMPLE
        : dataTypes[0] === PROPS
          ? PROPS
          : SCENIC
  //const { isAuthorized = () =>{} } = auth
  const downloadScenicCsvFunction = (shipmentId = '') => {
    dispatch(CsvDwonloadScenic(shipmentId))
  }
  let downloadCSVFunction = downloadCSFunction(dataShipmentId, 'CSVSHIP')
  if (itemType === SCENIC && isAuthorized(apiConfig.roles.scenic)) {
    downloadCSVFunction = (e) => downloadScenicCsvFunction(dataShipmentId)
  } else if (itemType === PROPS) {
    // TODO: CSVSHIP implementation pending from BE
    downloadCSVFunction = downloadCSFunction(dataShipmentId, 'CSV')
  } else if (itemType === 'COMBINED') {
    // TODO: FOR COMBINED CSV use BE download, now using FE download
    downloadCSVFunction = (e) => {
      const csvData = new Blob([createCsvUtil(renderData)], {
        type: 'text/csv',
      })
      const csvUrl = URL.createObjectURL(csvData)
      const link = document.createElement('a')
      link.href = csvUrl
      link.setAttribute('download', 'Shipment.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  const isShipmentTableEditable = isShipped ? isReuseShipment : true
  if (!isShipmentTableEditable) {
    readOnlyProps = {
      checkBoxEnabled: false,
    }
  }
  
  const renderTabbedPopUp = () => {
    const { type: itemType = '' } = popupItem
    const tabsList =
      itemType == SCENIC
        ? dataTabLabelsShippedWithScenic
        : itemType === PROPS
          ? dataTabLabelsShippedWithProps
          : dataTabLabelsShipped
    return (
      <TabbedPopUp
        dataTabLabels={tabsList}
        isVisible={popupIsVisible}
        data={makeTabTables(
          popupItem,
          classes,
          tabsList,
          updateSampleFieldsData
        )}
        onClose={closePopup}
        title={getTitle(popupItem)}
        fullWidth={true}
      />
    )
  }

  return (
    <>
      <div>
        {addSamplesRequestPending ? (
          <div>
            <CircularPageLoader open={addSamplesRequestPending} />
          </div>
        ) : (
          <div style={{ marginTop: '34px' }}>
            <FlexibleTableNew
              cascadeFieldKeys={[]}
              checkBoxEnabled={checkBoxEnabled}
              columnData={columnData}
              data={renderData}
              dataFieldKeys={dataFieldKeys}
              onClick={onClick}
              onEditChange={onEditChange}
              editEnabled={false}
              numSelected={numSelected}
              onCheckBoxChange={onCheckBoxChange}
              onCheckBoxHeaderChange={onCheckBoxHeaderChange}
              onSelected={onSelected}
              page={page}
              rowCount={renderData.length}
              rowsPerPage={rowsPerPage}
              selected={selectedData}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
              showPopup={showPopup}
              disableTablePagination={true}
              clickableColumn={clickableColumn}
              enableSearch
              enableMultiSearch
              enableSpacer={false}
              valueToCheckAgainst={valueToCheckAgainst}
              disableItems
              enableDownload
              enableContactSheetDownload
              launchInNewTabColumns={['mostRecentShipment']}
              launchInNewTabClick={(mostRecentShipment) => {
                window.open(
                  `/shipSamplesList/${mostRecentShipment}/edit`,
                  '_blank'
                )
              }}
              downloadFunction={downloadCSVFunction}
              downloadCSFunction={downloadCSFunction(dataShipmentId, 'XLSX')}
              downloadCSFunctionPDF={downloadCSFunction(dataShipmentId, 'PDF')}
              totalRowsCount={renderData?.length || 0}
              {...readOnlyProps}
            />
            {!!popupIsVisible && renderTabbedPopUp()}
          </div>
        )}
      </div>
    </>
  )
}

export default ShipmentTableData
